<script lang="ts">
  // One gesture unlocks audio playback and the microphone (iOS autoplay rules).
  let { title, subtitle = '', onstart }: { title: string; subtitle?: string; onstart: () => void } = $props();
</script>

<button class="gate" onclick={onstart}>
  <span class="t">{title}</span>
  {#if subtitle}<span class="sub">{subtitle}</span>{/if}
  <span class="tap">Tap to start</span>
  <span class="hint">Enables sound, microphone and keeps the screen awake</span>
</button>

<style>
  .gate {
    position: fixed; inset: 0; width: 100%; border: 0; border-radius: 0; background: #000; color: #fff;
    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 18px; padding: 24px;
  }
  .t { font-size: clamp(2rem, 8vw, 4rem); font-weight: 900; text-align: center; }
  .sub { color: var(--muted); font-size: 1.1rem; }
  .tap { margin-top: 24px; padding: 22px 48px; border-radius: 999px; background: var(--accent); font-size: 1.6rem; font-weight: 800; }
  .hint { color: var(--muted); font-size: 0.9rem; text-align: center; }
</style>
